import {Base, model, belongsTo, endpoint} from '@scoutgg/ftw/source/lib/model'
import moment from 'moment'

@model('Log')
@belongsTo('user')
@endpoint('logs', { root: '/api' })
export class Log extends Base {
  get subjectName() {
    if(/League/.test(this.action)) {
      return 'league'
    } else if(/Season/.test(this.action)) {
      return 'season'
    } else if(this.action === 'price') {
      return 'prices'
    } else if(this.action === 'lineup') {
      return 'lineups'
    } else {
      return this.action
        .split(/[a-z]([A-Z])/)
        .slice(-2)
        .join('')
        .toLowerCase() + 's'
    }
  }

  get subject() {
    return this.objects || this.object
  }
  get updatedValues() {
    return this.diff || {}
  }
  get time() {
    return moment(parseInt(this._id.slice(0, 8), 16) * 1000)
  }
}

